export default class Uri {
    constructor(uri = window.location.href) {
        this.uri = uri;

        this.components = this.parse();
    }

    // https://www.abeautifulsite.net/parsing-urls-in-javascript
    parse() {
        const parser = document.createElement('a');
        const searchObject = {};
        let queries, split, i;
        // Let the browser do the work
        parser.href = this.uri;
        // Convert query string to object
        queries = parser.search.replace(/^\?/, '').split('&');
        for( i = 0; i < queries.length; i++ ) {
            split = queries[i].split('=');
            searchObject[split[0]] = split[1];
        }

        return {
            protocol: parser.protocol,
            host: parser.host,
            hostname: parser.hostname,
            port: parser.port,
            pathname: parser.pathname,
            search: parser.search,
            searchObject: searchObject,
            hash: parser.hash
        };
    }

    get protocol() {
        return this.components.protocol;
    }

    get host() {
        return this.components.host;
    }

    get hostname() {
        return this.components.hostname;
    }

    get port() {
        return this.components.port;
    }

    get pathname() {
        return this.components.pathname;
    }

    get search() {
        return this.components.search;
    }

    get searchObject() {
        return this.components.searchObject;
    }

    get hash() {
        return this.components.hash;
    }
}
